import styled, { css } from 'styled-components';
import { propStyling } from '../../../shared/propStyling';
import { tombac } from '../../../shared/tombac';
const variantStyles = tombac.variant('variant', {
  default: css(["margin:", ";&:last-child{margin-bottom:", ";}"], tombac.space(2, 3, 0), tombac.space(2)),
  scrollable: css(["margin:", ";padding:", ";border:solid ", ";border-width:", ";overflow-y:auto;&:last-child{margin-bottom:", ";}"], tombac.space(3, 0, 0), tombac.space(2, 3), tombac.color('neutral', 400), tombac.unit(1, 0), tombac.space(3))
});
export const ModalContent = styled.div.attrs(_ref => {
  let {
    children,
    variant = 'default'
  } = _ref;
  return {
    children,
    variant
  };
}).withConfig({
  displayName: "ModalContent"
})(["", " ", " ", ""], tombac.text(), variantStyles, propStyling);
//# sourceMappingURL=ModalContent.js.map